// extracted by mini-css-extract-plugin
module.exports = {"root":"CommToolbar_root__1cFiL"};